import React from 'react';
import PointApprovalManagement from './PointApprovalManagement';

const PointApprovalManagementMonthly: React.FC = () => {
  return <PointApprovalManagement period="monthly" />;
};

export default PointApprovalManagementMonthly; 